import reactRender from "app/lib/reactRenderer";
import Playground from "app/components/Playground";

document.addEventListener("DOMContentLoaded", () => {
  reactRender(
    <Playground {...globalThis._playground} />,
    document.getElementById("playground"),
  );
});
